import * as Sentry from '@sentry/browser'
import { isAxiosError, type AxiosError } from 'axios'
import type { ComponentPublicInstance } from 'vue'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded } from 'vue-router'
import { useLegacyAppStore } from '@/store/legacy-app.store'

export function routerErrorHandler(
  error: unknown,
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded
) {
  console.error(error)
  Sentry.captureException(error, {
    extra: {
      to,
      from,
    },
  })
}

export function vueErrorHandler(
  error: unknown,
  instance: ComponentPublicInstance | null,
  info: string
) {
  if (isAxiosError(error)) {
    return handleAxiosError(error, instance, info)
  }

  console.error(error)
  Sentry.captureException(error, {
    extra: {
      componentInfo: info,
      component: instance?.$options.name,
    },
  })
  useLegacyAppStore().showErrorModal = true
}

function handleAxiosError(
  error: AxiosError,
  instance: ComponentPublicInstance | null,
  info: string
) {
  if (error.status === 401 && !instance?.$route.path.startsWith('/login')) {
    localStorage.removeItem('jwt_token')
    void instance?.$router.replace({
      path: '/login',
      query: {
        redirect: instance?.$route.fullPath !== '/' ? instance?.$route.fullPath : undefined,
      },
    })
    return
  }

  if (error.status === 404) {
    void instance?.$router.replace('/not-found')
    return
  }

  console.error(error)
  Sentry.captureException(error, {
    extra: {
      componentInfo: info,
      component: instance?.$options.name,
    },
  })

  useLegacyAppStore().showErrorModal = true
}
